export const CUSTOMER_LABEL_CHARACTER_LIMIT = 60
